
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { getCountries, getManufacturers } from '@/lib/utilities/repository';
import type { GetStaticProps, NextPage } from 'next';
import { NextSeo } from 'next-seo';
import useTranslation from 'next-translate/useTranslation';
import { SWRConfig } from 'swr';
import { SellForm } from '../components/Form/SellForm';
import StaticPageTemplate from '@/components/StaticTemplate';

function StepsList() {
  const { t } = useTranslation('common');
  return (
    <>
      <SEO />
      <section className='body-font text-gray-600'>
        <div className=' mx-auto flex flex-wrap py-12'>
          <div className='flex w-full flex-wrap'>
            <div className=''>
              <div className='relative flex pb-12'>
                <div className='absolute inset-0 flex h-full w-10 items-center justify-center'>
                  <div className='pointer-events-none h-full w-1 bg-gray-200' />
                </div>
                <div className='relative z-10 inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-orange-500 text-white'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    className='h-6 w-6'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10'
                    />
                  </svg>
                </div>
                <div className='flex-grow pl-4'>
                  <h2 className='title-font upper mb-1 text-sm font-medium tracking-wider text-gray-900'>
                    {t('common:Step1')}
                  </h2>
                  <p className='leading-relaxed'>
                    {t('common:Send machine data')}
                  </p>
                </div>
              </div>
              <div className='relative flex pb-12'>
                <div className='absolute inset-0 flex h-full w-10 items-center justify-center'>
                  <div className='pointer-events-none h-full w-1 bg-gray-200' />
                </div>
                <div className='relative z-10 inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-orange-500 text-white'>
                  <svg
                    fill='none'
                    stroke='currentColor'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    className='h-5 w-5'
                    viewBox='0 0 24 24'
                  >
                    <path d='M22 12h-4l-3 9L9 3l-3 9H2' />
                  </svg>
                </div>
                <div className='flex-grow pl-4'>
                  <h2 className='title-font mb-1 text-sm font-medium tracking-wider text-gray-900'>
                    {t('common:Step2')}
                  </h2>
                  <p className='leading-relaxed'>
                    {t('common:Market value appraisal')}
                  </p>
                </div>
              </div>
              <div className='relative flex pb-12'>
                <div className='absolute inset-0 flex h-full w-10 items-center justify-center'>
                  <div className='pointer-events-none h-full w-1 bg-gray-200' />
                </div>
                <div className='relative z-10 inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-orange-500 text-white'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    strokeWidth={2}
                    className='h-5 w-5'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                    />
                  </svg>
                </div>
                <div className='flex-grow pl-4'>
                  <h2 className='title-font mb-1 text-sm font-medium tracking-wider text-gray-900'>
                    {t('common:Step3')}
                  </h2>
                  <p className='leading-relaxed'>
                    {t('common:Global marketing')}
                  </p>
                </div>
              </div>
              <div className='relative flex pb-12'>
                <div className='absolute inset-0 flex h-full w-10 items-center justify-center'>
                  <div className='pointer-events-none h-full w-1 bg-gray-200' />
                </div>
                <div className='relative z-10 inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-orange-500 text-white'>
                  <svg
                    fill='none'
                    stroke='currentColor'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    className='h-5 w-5'
                    viewBox='0 0 24 24'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z'
                    />
                  </svg>
                </div>
                <div className='flex-grow pl-4'>
                  <h2 className='title-font mb-1 text-sm font-medium tracking-wider text-gray-900'>
                    {t('common:Step4')}
                  </h2>
                  <p className='leading-relaxed'>
                    {t('common:Secure payment')}
                  </p>
                </div>
              </div>
              <div className='relative flex'>
                <div className='relative z-10 inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-orange-500 text-white'>
                  <svg
                    fill='none'
                    stroke='currentColor'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    className='h-5 w-5'
                    viewBox='0 0 24 24'
                  >
                    <path d='M22 11.08V12a10 10 0 11-5.93-9.14' />
                    <path d='M22 4L12 14.01l-3-3' />
                  </svg>
                </div>
                <div className='flex-grow pl-4'>
                  <h2 className='title-font mb-1 text-sm font-medium tracking-wider text-gray-900'>
                    {t('common:Step5')}
                  </h2>
                  <p className='leading-relaxed'>{t('common:Logistics')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
interface SellProps {
  fallback: any;
}

const ProductsIndex: NextPage<SellProps> = ({ fallback }) => {
  const { t } = useTranslation('common');
  const title = t('Sell Used Beverage Machines');
  const subtitle = t(
    'We offer a hassle-free sale of used beverage machines for best market prices'
  );
  const components = [
    <SWRConfig value={{ fallback }} key='config'>
      <div className='!my-0 grid grid-cols-1 md:grid-cols-2 lg:gap-8'>
        <div className='flex flex-col p-8 md:space-y-8 '>
          <div className='flex flex-col items-center'>
            <h4 className='text-start text-2xl font-semibold text-black'>
              {t('How it works?')}
            </h4>
            <StepsList />
          </div>
        </div>
        <div className='space-y-12 md:p-8 '>
          <h3 className='text-center text-2xl font-semibold  text-black'>
            {t('Send Us Your Machine Information')}
          </h3>
          <SellForm />
        </div>
      </div>
    </SWRConfig>,
  ];

  return (
    <StaticPageTemplate
      title={title}
      subtitle={subtitle}
      components={components}
    />
  );
};
function SEO() {
  const { t } = useTranslation();
  return (
    <NextSeo
      title={t('seo:sell.title')}
      description={t('seo:sell.description')}
      openGraph={{
        url: process.env.SITE_URL_EN,
        title: t('seo:sell.title'),
        description: t('seo:sell.description'),
        images: [
          {
            url: process.env.NEXT_PUBLIC_IMAGES_URL + '/logo.jpg',
          },
        ],
        site_name: 'BEVMAQ',
        type: 'article',
      }}
    />
  );
}

 const _getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      hasContainer: false,
      fallback: {
        [`/api/countries/${locale}`]: await getCountries(locale),
        [`/api/manufacturers/${locale}`]: await getManufacturers(locale),
      },
    },
  };
};

export default ProductsIndex;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/sell',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  